module.exports = __webpack_public_path__ + "img/car_sendai10.f29b4396.jpg";